module.exports = __webpack_public_path__ + "static/media/logo.fbde3401.png";